import { Flow_0_0_2 } from '@flexus/core';

export const SIL_100: Flow_0_0_2 = {
	id: '100',
	name: 'claim_moved_to_la',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
